<template>
  <v-dialog
    @input="v => v || onClose()"
    v-model="showDialog"
    scrollable
    transition="dialog-bottom-transition"
    width="500">
    <v-card>
      <v-card-title
        class="headline grey lighten-2"
        primary-title
      >
        Scheduler for {{ location.Name }}
      </v-card-title>
      <v-card-text class="scheduler-modal__card-text">
        <scheduler :searchable="showDialog" @selectDate="selectDate"></scheduler>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import Scheduler from './index.vue'

export default {
  props: {
    showDialog: {
      type: Boolean
    }
  },
  components: {
    Scheduler
  },
  computed: {
    ...mapGetters({
      location: 'user/getLocation'
    })
  },
  methods: {
    onClose () {
      this.$emit('close')
    },
    selectDate (appointmentSlot, date) {
      this.$emit('selectDate', appointmentSlot, date)
      this.$emit('close')
    }
  }
}
</script>

<style>
.scheduler-modal__card-text {
  background-color: #f6f7f9;
}
</style>
